<template>
  <div>
    <vs-popup
      :title="$t('DescriptionAndDateSettlement')"
      :active.sync="showModal"
    >
      <form>
        <div class="vx-row mb-4">
          <div class="vx-col w-1/2 mt-1">
            <vs-input
              class="w-full"
              :label="$t('Description')"
              v-model="modelForClose.description"
              placeholder="توضیحات برای تدبیر"
            />
          </div>
          <div class="vx-col w-1/2">
            <label class="vs-select--label datepicker-lb">{{
              $t("DateSettlement")
            }}</label>
            <date-picker
              v-model="modelForClose.DateSettlement"
              type="datetime"
              format="jYYYY-jMM-jDD HH:mm:ss"
              display-format="jYYYY-jMM-jDD HH:mm:ss"
              class="date-picker"
              :label="$t('Calendar')"
              :clearable="true"
            />
          </div>
          <div class="vx-col w-1/2 mt-1">
            <vs-input
              class="w-full"
              :label="$t('Considerations')"
              v-model="modelForClose.considerations"
              placeholder="ملاحضات درون‌سازمانی"
            />
          </div>
        </div>
      </form>
      <div>
        <span v-if="showErr" class="text-danger">
          * لطفا تاریخ تسویه را وارد کنید
        </span>
      </div>
      <div>
        <span
          v-if="!modelForClose.description || !modelForClose.considerations"
          class="text-danger"
        >
          * درج توضیحات و ملاحضات اختیاری است
        </span>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <vs-button
            type="filled"
            class="float-right mb-4"
            @click.prevent="submitForm"
            >{{ $t("Save") }}</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    show: { default: false },
  },
  data() {
    return {
      modelForClose: {
        description: "",
        DateSettlement: "",
        considerations: "",
      },
      showErr: false,
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("finish");
      },
    },
  },
  methods: {
    submitForm() {
      if (this.modelForClose.DateSettlement == "") {
        this.showErr = true;
      } else {
        this.$emit("CloseOrderBasket", this.modelForClose);
      }
    },
  },

  components: {},
};
</script>
